import type { CategoryRecord, OptionCategory } from "@/types/recipe";

export const INTENT_OPTIONS = [
  "high protein",
  "low calories",
  "high calories",
  "quick meal",
  "nutrient dense",
  "vegan",
];
export const PROTEIN_OPTIONS = [
  "chicken breasts",
  "ground beef",
  "eggs",
  "salmon",
  "tuna",
  "tofu",
  "turkey",
  "pork loin",
];
export const VEGETABLE_OPTIONS = [
  "carrots",
  "onion",
  "garlic",
  "red pepper",
  "green pepper",
  "broccoli",
  "spinach",
  "tomatoes",
];
export const SIDES_OPTIONS = [
  "brown rice",
  "white rice",
  "potatoes",
  "sweet potatoes",
  "couscous",
  "pasta",
];
export const SPICES_OPTIONS = [
  "turmeric",
  "curry",
  "paprika",
  "cumin",
  "oregano",
  "basil",
  "thyme",
];
export const APPLIANCE_OPTIONS = [
  "oven",
  "caceroles",
  "frying pans",
  "slow cooker",
  "air fryer",
  "grill",
];

export const OPTION_CATEGORIES: OptionCategory[] = [
  "intent",
  "protein",
  "vegetables",
  "sides",
  "spices",
  "appliance",
];

export const baseOptions: CategoryRecord<string[]> = {
  intent: INTENT_OPTIONS,
  protein: PROTEIN_OPTIONS,
  vegetables: VEGETABLE_OPTIONS,
  sides: SIDES_OPTIONS,
  spices: SPICES_OPTIONS,
  appliance: APPLIANCE_OPTIONS,
};

export const makeCategoryRecord = <T>(value: () => T): CategoryRecord<T> =>
  OPTION_CATEGORIES.reduce((acc, category) => {
    acc[category] = value();
    return acc;
  }, {} as CategoryRecord<T>);
